import React from "react";

const InfoIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1.33333C4.32 1.33333 1.33334 4.32 1.33334 8C1.33334 11.68 4.32 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8C14.6667 4.32 11.68 1.33333 8 1.33333ZM8.66667 11.3333H7.33334V7.33333H8.66667V11.3333ZM8.66667 6H7.33334V4.66667H8.66667V6Z"
        fill="#A78BFA"
      />
    </svg>
  );
};

export default InfoIcon;